<header>
  <h2>{{ title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</header>
<div class="container">
  <nav *ngIf="filters.length">
    <button
      *ngFor="let filter of filters"
      [class.active]="filter === filterActive"
      (click)="handleFilter(filter)"
    >
      {{ filter }}
    </button>
  </nav>
  <ul>
    <li *ngFor="let item of list">
      <div class="item-container" (click)="handleItemClick(item)">
        <mat-icon>{{ getIcon(item.type) }}</mat-icon>
        <div class="item-info">
          <p>{{ item.name }}{{ item.extension ? "." + item.extension : "" }}</p>
          <p class="date">{{ item.date | date : DATE_FORMATS.detail }}</p>
        </div>
        <button mat-icon-button style="margin-left: 10px" color="primary">
          <mat-icon>{{
            item.type === "Link"
              ? "open_in_new"
              : item.type === "Dashboard"
              ? "launch"
              : "download"
          }}</mat-icon>
        </button>
      </div>
    </li>
    <li *ngIf="list.length === 0 && !loading">
      <p class="empty">No records found</p>
    </li>
  </ul>
</div>
